import React from "react";

export default function SolarHamburgerMenuLinear(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.2em"
      height="1.2em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.8}
        d="M20 7H4m16 5H4m16 5H4"
      ></path>
    </svg>
  );
}
